import styled, { css } from "styled-components";

interface MobileProgressStyledProps {
  c2fEnabled?: boolean;
  mobileReductionEnabled?: boolean;
}

const MobileProgressStyled = styled.div.attrs({
  className: "mobile-progress",
})<MobileProgressStyledProps>`
  ${({ theme, c2fEnabled, mobileReductionEnabled }) => {
    const { colors } = theme;

    return css`
      display: flex;
      align-items: center;
      padding: ${mobileReductionEnabled ? "16px 24px 32px" : "24px"};
      background-color: ${colors.primary.white};
      overflow: hidden;
      width: 100%;

      .mobile-progress__step {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        min-width: 0;
        border: none;
        background: none;
      }

      .mobile-progress__step--active .mobile-progress__line {
        background-color: ${colors.primary.gravity};
      }

      .mobile-progress__step--active .mobile-progress__label {
        color: ${colors.primary.gravity};
      }

      .mobile-progress__step--inactive .mobile-progress__line {
        background-color: ${colors.secondary.pumice};
      }

      .mobile-progress__step--inactive .mobile-progress__label {
        color: ${colors.secondary.pumice};
      }

      .mobile-progress__line {
        width: ${c2fEnabled ? "90%" : "75.7px"};
        height: 2px;
        border-radius: 2px;
        margin-bottom: 8px;
        flex-shrink: 0;
      }

      .mobile-progress__label {
        font-size: 14px;
        font-weight: 700;
        text-align: center;
        line-height: 20px;
        letter-spacing: 0px;
      }
    `;
  }}
`;

export default MobileProgressStyled;
